<template>
  <div :style="boxWrapStyleObj" class="nj-header-title" style="position: relative;">
    <div class="header-title-area" ref="statisTitle">
      <div class="area-title">
        <img src="../../../assets/images/nanjindataboard/right-row.png" />
        <p class="title-text">区域分布数</p>
      </div>
      <img
        src="../../../assets/images/nanjindataboard/bottom-bg.png"
        style="float: left"
      />
    </div>
    <div :style="contentStyleObj">
      <!--图例-->
      <div class="echart-legend">
        <div class="legend-item" @click="selectLegend('')">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '' || legendIndex == '全部'
                ? { background: 'red' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">全部</p>
        </div>
        <div class="legend-item" @click="selectLegend('小学')">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '' || legendIndex == '小学'
                ? { background: '#24C4DC' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">小学</p>
        </div>
        <div class="legend-item" @click="selectLegend('初中')">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '' || legendIndex == '初中'
                ? { background: '#ED8167' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">初中</p>
        </div>
        <div class="legend-item" @click="selectLegend('高中')">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '' || legendIndex == '高中'
                ? { background: '#FAE17C' }
                : { background: '#ccc' }
            "
          ></p>
          <p class="legend-item-text">高中</p>
        </div>
      </div>
      <!--区域分布数-->
      <!-- <new-again-histogram-charts
                    ref="districtDisRef"
                    :chartsId="'district_dis_data'"
                    :showTitle="false"
                    :height="contentStyleObj.height"
                    :tooltip="tooltip"
                    :legend="legend"
                    :xAxis="xAxis"
                    :yAxis="yAxis"
            ></new-again-histogram-charts> -->
      <div :padding="0">
        <!--图表-->
        <div :style="{ height: contentStyleObj.height }">
          <div
            style="width: 100%; height: 100%"
            :id="'district_dis_data'"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const newAgainHistogramCharts = () =>
//   import("../../../components/charts/newAgainHistogramCharts");

export default {
  name: "district-dis-statics",
  components: {
    // newAgainHistogramCharts,
  },
  props: {
    screenHeight: Number,
    titleHeight: Number,
  },
  data() {
    return {
      legendIndex: "",
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      tooltip: {},
      legend: {},
      xAxis: {},
      yAxis: {},
    };
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * 图例切换
     */
    selectLegend(item) {
      let seriesDataArr = [];
      this.legendIndex = item;
      if (item == "小学") {
        seriesDataArr = [
          {
            name: "小学",
            type: "bar",
            stack: "phase",
            color: "#24C4DC",
            barWidth: "30",
            barGap: "80%",
            data: [
              "16",
              "32",
              "23",
              "21",
              "32",
              "22",
              "19",
              "35",
              "19",
              "11",
              "11",
            ],
          },
          {
            name: "初中",
            type: "bar",
            stack: "phase",
            color: "#ED8167",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
          {
            name: "高中",
            type: "bar",
            stack: "phase",
            color: "#FAE17C",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
        ];
      } else if (item == "初中") {
        seriesDataArr = [
          {
            name: "小学",
            type: "bar",
            stack: "phase",
            color: "#24C4DC",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
          {
            name: "初中",
            type: "bar",
            stack: "phase",
            color: "#ED8167",
            barWidth: "30",
            barGap: "80%",
            data: ["6", "7", "8", "8", "14", "2", "7", "12", "6", "1", "2"],
          },
          {
            name: "高中",
            type: "bar",
            stack: "phase",
            color: "#FAE17C",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
        ];
      } else if (item == "高中") {
        seriesDataArr = [
          {
            name: "小学",
            type: "bar",
            stack: "phase",
            color: "#24C4DC",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
          {
            name: "初中",
            type: "bar",
            stack: "phase",
            color: "#ED8167",
            barWidth: "30",
            barGap: "80%",
            data: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
          },
          {
            name: "高中",
            type: "bar",
            stack: "phase",
            color: "#FAE17C",
            barWidth: "30",
            barGap: "80%",
            data: ["2", "6", "2", "2", "4", "1", "3", "8", "3", "0", "0"],
          },
        ];
      } else if (item == "") {
        seriesDataArr = [
          {
            name: "小学",
            type: "bar",
            stack: "phase",
            color: "#24C4DC",
            barWidth: "30",
            barGap: "80%",
            data: [
              "16",
              "32",
              "23",
              "21",
              "32",
              "22",
              "19",
              "35",
              "19",
              "11",
              "11",
            ],
          },
          {
            name: "初中",
            type: "bar",
            stack: "phase",
            color: "#ED8167",
            barWidth: "30",
            barGap: "80%",
            data: ["6", "7", "8", "8", "14", "2", "7", "12", "6", "1", "2"],
          },
          {
            name: "高中",
            type: "bar",
            stack: "phase",
            color: "#FAE17C",
            barWidth: "30",
            barGap: "80%",
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 0, 0],
              },
            },
            data: ["2", "6", "2", "2", "4", "1", "3", "8", "3", "0", "0"],
          },
        ];
      }
      this.getDsitrictDisData(seriesDataArr);
    },
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }

      let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 2.5;
      let contentHeight =
        boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    /**
     * 获取区域分布数据
     */
    getDsitrictDisData(seriesDataArr) {
      let _this = this;
      let xDataArr = [
        "墨江哈尼族",
        "孟连傣族拉祜族佤族",
        "宁洱哈尼族彝族",
        "思茅区",
        "景东彝族",
        "景谷傣族彝族",
        "江城哈尼族彝族",
        "澜沧拉祜族",
        "西盟佤族",
        "镇沅彝族哈尼族拉祜族"
      ];
      _this.legend = {
        show: false,
        data: ["小学", "初中", "高中"],
        right: "10",
        itemWidth: 14,
        itemHeight: 14,
        textStyle: {
          color: "#708ACC",
          fontSize: "14px",
        },
      };
      _this.xAxis = [
        {
          type: "category",
          show: true,
          axisTick: { show: false },
          axisLabel: {
            interval: 0,
            rotate: 40,
            textStyle: {
              color: "#708ACC", //颜色
              fontSize: "16", //大小
            },
              //坐标轴刻度标签的相关设置。
              formatter: function (params) {
                  var newParamsName = "";// 最终拼接成的字符串

                      var paramsNameNumber = params.length;// 实际标签的个数
                      var rowNumber = Math.ceil(paramsNameNumber / 6);// 换行的话，需要显示几行，向上取整
                      //判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                      if (paramsNameNumber > 6) {
                          /** 循环每一行,p表示行 */
                          for (var p = 0; p < rowNumber; p++) {
                              var tempStr = "";// 表示每一次截取的字符串
                              var start = p * 4;// 开始截取的位置
                              var end = start + 4;// 结束截取的位置
                              // 此处特殊处理最后一行的索引值
                              if (p == rowNumber - 1) {
                                  // 最后一次不换行
                                  tempStr = params.substring(start, paramsNameNumber);
                              } else {
                                  // 每一次拼接字符串并换行
                                  tempStr = params.substring(start, end) + "\n";
                              }
                              newParamsName += tempStr;// 最终拼成的字符串
                          }

                      } else {
                          // 将旧标签的值赋给新标签
                          newParamsName = params;
                      }

                  //将最终的字符串返回
                  return newParamsName
              }
          },
          axisLine: {
            show: true,
            lineStyle: { color: "#6076AD" },
          },
        },
      ];
      _this.yAxis = [
        {
          type: "value",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#708ACC", //颜色
              fontSize: "16", //大小
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#6076AD",
              opacity: 0.3,
            },
          },
        },
      ];
      (_this.tooltip = {
        show: true,
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      }),
        this.$nextTick(() => {
        //   setTimeout(function () {
        // _this.$refs.districtDisRef.initDataSource(xDataArr, seriesDataArr);
        _this.initDataSource(xDataArr, seriesDataArr);
      //   }, 500);
      });
    },
    /**
     * 加载图表数据
     */
    initDataSource(xDataArr, seriesDataArr) {
      let _this = this;
      let dataSource = _this.$echarts.init(
        document.getElementById("district_dis_data")
      );
      _this.xAxis[0].data = xDataArr;
      dataSource.off("click");
      const option = {
        tooltip: _this.tooltip,
        xAxis: _this.xAxis,
        yAxis: _this.yAxis,
        //距离上下左右的距离
        grid: {
          left: "3%",
          right: "4%",
          bottom: "7%",
          top: "7%",
          containLabel: true,
        },
        series: seriesDataArr,
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
        dataSource.resize();
      });
    },
  },
  mounted() {
    this.initBoxHeight();
    let seriesDataArr = [
      {
        name: "小学",
        type: "bar",
        stack: "phase",
        color: "#24C4DC",
        barWidth: "30",
        barGap: "80%",
        data: [
          "16",
          "32",
          "23",
          "21",
          "32",
          "22",
          "19",
          "35",
          "19",
          "11",
          "11",
        ],
      },
      {
        name: "初中",
        type: "bar",
        stack: "phase",
        color: "#ED8167",
        barWidth: "30",
        barGap: "80%",
        data: ["6", "7", "8", "8", "14", "2", "7", "12", "6", "1", "2"],
      },
      {
        name: "高中",
        type: "bar",
        stack: "phase",
        color: "#FAE17C",
        barWidth: "30",
        barGap: "80%",
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [4, 4, 0, 0],
          },
        },
        data: ["2", "6", "2", "2", "4", "1", "3", "8", "3", "0", "0"],
      },
    ];
    //获取区域分布数据
    this.getDsitrictDisData(seriesDataArr);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
</style>